import React from 'react'
import { IInfoConfirmProcess } from '../../cardGrid/cardGrid'
import { getTranslateByKey, isNullUndefined, openNewTabExternalLink } from '@/main/services/utils';
import KogInputText from '@/main/components/shared/inputText/inputText';
import * as S from './styles'

interface IContentReturnApprovalProps {
  infoConfirmProcess: IInfoConfirmProcess
}
function ContentReturnApproval({
  infoConfirmProcess
}: IContentReturnApprovalProps) {
  return (
    <S.Container>
      {infoConfirmProcess.reason && <KogInputText label={getTranslateByKey('information.reason')} value={infoConfirmProcess.reason} disabled />}
      {!isNullUndefined(infoConfirmProcess.reasonDescription) && <KogInputText label={getTranslateByKey('information.observation')} value={infoConfirmProcess.reasonDescription} disabled />}
      <S.ContainerImages>
        {infoConfirmProcess.imagesReturnProcess
          && infoConfirmProcess.imagesReturnProcess.map(
            (image) => <S.Image src={image.externalKey} onClick={() => openNewTabExternalLink(image.externalKey)} />
          )
        }
      </S.ContainerImages>

    </S.Container>
  )
}

export default ContentReturnApproval